<template>
  <v-row dense class="lesson-list">
    <v-col cols="12">
      <div v-if="exerciseList.status === 'FE'" class="primary--text header bold">
        Esta lista de exercícios foi finalizada pelo sistema
      </div>
      <div class="answered text-center text-sm-right blue-grey--text text--darken-2">
        Respondidos {{exercise.answeredCounters['answered']}} / {{exercise.answeredCounters['count']}}
      </div>
      <div v-if="deadlineCountDown.show" class="deadline-countdown text-center">
        <div class="deadline-start">
          <label>Início: </label>
          <strong>{{ exerciseListStart }}</strong>
        </div>
        <div v-if="deadlineCountDown.expired" class="deadline-expired">
          Tempo Expirado
        </div>
        <div v-else class="deadline-timer">
          <label>Tempo restante: </label>
          <strong>{{ deadlineCountDown.timer }}</strong>
        </div>
      </div>
    </v-col>

    <v-col cols="12">
      <div class="header bold text-center">Exercício {{getExerciseTitleText(exercisePosition, 1)}}</div>
      <div v-if="isAnsweredBySystem" class="primary--text">
        Este exercício não foi respondido dentro do tempo hábil da lista de exercícios,
        e portanto foi fechado pelo sistema.
      </div>
    </v-col>

    <v-col cols="12">
      <v-runtime-template class="content column" :template="exercise.exercise.question"/>
      <!-- <div class="content" v-html="exercise.exercise.question"></div> -->
    </v-col>

    <v-col cols="12" v-if="showYourAnswer">
      <div class="your-answer">
        <v-card outlined flat>
          <v-card-title>
            <v-col cols="12">
              <div class="text-h5 card-content text-center">Sua resposta</div>
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <v-runtime-template v-if="exercise.reply" :template="exercise.reply" class="answer-content"/>
              <nt-audiorecorder v-if="exercise.file_id" :audio-file="fileData()" @recorded="recordedHandle"/>
            </v-col>
          </v-card-text>
        </v-card>
      </div>
    </v-col>

    <v-col cols="12" v-if="showOptions">
      <v-row dense>
        <v-col cols="12" v-for="(option, index) in exercise.exercise.exercise_options" :key="option.id">
          <v-card outlined flat @click.stop="setObjectAnswer(option)"
                  :class="[{ 'green lighten-3': isTheOptionCorrect(option), 'red lighten-3': isTheOptionIncorrect(option) }]">
            <v-card-text>
              <v-row dense>
                <v-col class="shrink">
                  <v-checkbox v-model="exercise.exercise_option_id" :value="option.id" :disabled="exercise.exerciseIsReplied"
                              @change="setObjectAnswer(option)"/>
                </v-col>
                <v-col class="grow text-left">
                  <div class="font-weight-bold" v-html="'Alternativa ' + getAlternativeText(index)"></div>
                  <v-runtime-template class="option-description font-weight-medium" :template="option.description"/>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" v-if="exercise.exercise.exercise_tips.length !== 0">
      <div class="exercise-tips">
        <ul>
          <li class="tip" v-for="tip in exercise.exercise.exercise_tips" :key="tip.id">
            <div class="tip-title" v-html="tip.title"></div>
            <div class="tip-description" v-html="tip.description"></div>
          </li>
        </ul>
      </div>
    </v-col>

    <v-col cols="12">
      <div class="answer">
        <div class="answer-form text-center" v-if="showTextArea">
          <div class="answer-upload" v-if="uploadForm.model">
            <nt-mediaupload @newUpload="newFile"/>
            <template v-if="uploadForm.list">
              <v-row dense>
                <!-- Template para os ítens da listagem -->
                <nt-medialistitem
                  v-for="(file, i) in files"
                  :key="i"
                  :dataset="file"
                  :event="'manager'"
                  @delete="deleteFile"
                  deleteable/>
              </v-row>
            </template>
          </div>

          <v-textarea outlined hide-details="auto" label="Digite sua resposta aqui." v-else-if="showTextArea" v-model="exercise.reply" rows="7" cols="100" />

          <!-- Mostra este botão apenas quando a variável uploadForm.list for falsa, ou seja, quando a lista
            de arquivos que foram feitos upload estiver vazia -->
          <v-btn depressed class="mt-4" v-if="!uploadForm.list && exercise.exercise.type !== 'DD'" color="warning" ligth dark @click.stop="uploadArea().show()">
            <label v-if="uploadForm.model">Resposta em texto</label>
            <label v-else>Upload Imagem</label>
            <v-icon v-if="!uploadForm.model" right dark>mdi-cloud-upload</v-icon>
          </v-btn>
        </div>

        <div class="answer-multimedia" v-else-if="exercise.exercise.type === 'M' && !exercise.exerciseIsReplied">
          <nt-audiorecorder :audio-file="fileData()" @recorded="recordedHandle"/>
        </div>

        <v-card outlined flat v-if="exercise.exerciseIsReplied">
          <v-card-title v-if="isObjectiveExercise && exerciseJustification">
            <v-col cols="12">
              <div class="text-h5 card-content">Justificativa:</div>
              <div class="card-content" v-html="exerciseJustification"></div>
            </v-col>
          </v-card-title>
        </v-card>

        <v-card outlined flat v-if="exercise.exerciseIsReplied && (exercise.feedback || exercise.feedback_file_id || exercise.grade || exercise.grade === 0)">
          <v-card-title>
            <v-col cols="12">
              <div class="text-h5 card-content text-center">Correção</div>
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-col cols=12>
              <div v-if="exercise.grade || exercise.grade === 0" class="text-xs-left subheading">
                <strong>Nota:</strong> {{ exercise.grade }}
              </div>
              <div v-if="exercise.feedback || exercise.feedback_file_id" class="exercise-feedback">
                <div class="text-xs-left subheading">
                  <strong>Considerações do corretor:</strong>
                </div>

                <v-runtime-template v-if="exercise.feedback" class="card-content" :template="exercise.feedback"/>

                <div class="feedback-audio" v-if="exercise.feedback_file_id">
                  <label><strong>Áudio:</strong></label>
                  <nt-audiorecorder :audio-file="feedbackData()" @recorded="recordedHandle"/>
                </div>
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </div>
    </v-col>

    <v-col cols="12" v-if="!exercise.exerciseIsReplied && !isAnsweredBySystem">
      <div class="text-center">
        <v-btn
          block
          text
          :loading="sendingAnswer"
          :disabled="sendingAnswer"
          color="green"
          @click.native="answerExercise()">
          <v-icon left>mdi-cloud-upload</v-icon> Enviar Resposta
        </v-btn>
        <div>
          <small>Clique em <b>enviar resposta</b> para marcar o exercício como respondido.</small>
        </div>
      </div>
    </v-col>

    <v-row dense v-if="showNavigationButtons" class="mt-2">
      <v-tooltip top v-if="isPreviousLesson || previousExercise !== 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on" large color="info" @click="toPrevious()">
            <v-icon dark>mdi-skip-previous</v-icon>
          </v-btn>
        </template>
        <span v-if="previousExercise === 0">Aula anterior: {{ previousLesson.title }}</span>
        <span v-else>Exercício anterior: Exercício {{ getExerciseTitleText(exercisePosition, 0) }}</span>
      </v-tooltip>
      <v-spacer class="text-center" v-html="getExerciseTitleText(exercisePosition, 1) + '/' + totalExercises"></v-spacer>
      <v-tooltip top v-if="isNextLesson || nextExercise !== 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on" large color="info" @click="toNext()">
            <v-icon dark>mdi-skip-next</v-icon>
          </v-btn>
        </template>
        <span v-if="nextExercise === 0">Próxima aula: {{ nextLesson.title }}</span>
        <span v-else>Próximo exercício: Exercício {{ getExerciseTitleText(exercisePosition, 2) }}</span>
      </v-tooltip>
    </v-row>
  </v-row>
</template>

<script>
import { SalaDeAula, File, AuthFile } from '@/services/resources'
import { mapGetters } from 'vuex'
import VueRuntimeTemplate from '@/components/Utils/VueRuntimeTemplate'
import MediaUpload from '@/components/Media/MediaUpload'
import MediaItem from '@/components/Media/MediaItem'
import AudioRecorder from '@/components/Utils/Audio/AudioRecorder'

const defaultFileForm = () => {
  return {
    id: 0,
    data: null,
    path: ''
  }
}

const defaultExerciseData = () => {
  return {
    id: 0,
    exercise: {
      id: 0,
      question: '',
      cells_number: 0,
      exercise_tips: [],
      exercise_options: [],
      type: ''
    },
    exercise_id: 0,
    exercise_option_id: 0,
    cells_answers: [],
    instance_id: 0,
    file: defaultFileForm(),
    feedbackFile: defaultFileForm(),
    reply: null,
    feedback: null,
    exerciseIsReplied: false,
    exerciseIsHalfReplied: false,
    answeredCounters: {
      count: 0,
      answered: 0
    }
  }
}

const defaultUploadForm = () => {
  return {
    model: false,
    list: false
  }
}

const defaultDeadlineCountDown = () => {
  return {
    timer: '00min e 00s',
    expired: false,
    show: false
  }
}

const defaultData = () => {
  return {
    totalExercises: 0,
    exercisePosition: 0,
    nextExercise: 0,
    previousExercise: 0,
    exercise: defaultExerciseData(),
    uploadForm: defaultUploadForm(),
    files: [],
    deadlineCountDown: defaultDeadlineCountDown(),
    countDown: null
  }
}

export default {
  components: {
    'v-runtime-template': VueRuntimeTemplate,
    'nt-mediaupload': MediaUpload,
    'nt-medialistitem': MediaItem,
    'nt-audiorecorder': AudioRecorder
  },
  props: {
    exerciseList: {
      type: Object,
      default () {
        return {}
      },
      required: true
    },
    progress: {
      type: Number,
      default: 0,
      required: true
    },
    previousLesson: {
      type: Object,
      default () {
        return {}
      },
      required: false
    },
    nextLesson: {
      type: Object,
      default () {
        return {}
      },
      required: false
    },
    matriculaId: {
      type: Number,
      default: 0,
      required: true
    },
    aulaId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data () {
    return defaultData()
  },
  methods: {
    /**
     * Função que altera do data que controla o estado do form de upload de arquivos
     * @return {Object} objeto com funções filhas
     */
    uploadArea () {
      const vm = this
      return {
        show () {
          vm.uploadForm.model = !vm.uploadForm.model
        },
        showList () {
          vm.uploadForm.list = !vm.uploadForm.list
        }
      }
    },
    resetExerciseData () {
      Object.assign(this.exercise, defaultExerciseData())
    },
    setExercise () {
      SalaDeAula.getExercise(this.exerciseList.nextExercise)
        .then(async (response) => {
          // this.resetExerciseData()
          Object.assign(this.exercise, response.body.return.exercise_list_instance)
          this.exercise.exerciseIsReplied = response.body.return.exercise_is_replied
          this.exercise.exerciseIsHalfReplied = response.body.return.exercise_is_half_replied
          Object.assign(this.exercise.answeredCounters, response.body.return.answered_counters)
          Object.assign(this.uploadForm, defaultUploadForm())

          switch (this.exercise.exercise.type) {
            case 'OL':
            case 'DL':
              this.exercise.cells_answers = [...Array(this.exercise.exercise.cells_number).keys()]
                .map(i => ({ cell: i, exercise_option_id: null, reply: '' }))
              break

            case 'OM':
              if (!this.exercise.exercise_option_id) {
                this.exercise.exercise_option_id = []
              }
              break

            case 'M':
              if (!this.exercise.file_id) {
                this.exercise.file = { ...defaultFileForm() }
              } else {
                await this.loadRecord(this.exercise.file_id)
              }
              break
          }

          if (!this.exercise.feedback_file_id) {
            this.exercise.feedbackFile = { ...defaultFileForm() }
          } else {
            await this.loadFeedbackRecord(this.exercise.feedback_file_id)
          }

          this.setPreviousAndNextExercise()
          this.$nextTick(() => {
            const wrapperLessonContent = document.querySelector('.wrapper-lesson-content')
            window.scrollTo(0, wrapperLessonContent.offsetTop - 56)
          })

          // Caso a quantidade de exercícios respondidos pelo aluno
          // seja diferente da quantidade de exercícios total, inicializa
          // o contador da deadline da lista de exercícios
          if (this.exercise.answeredCounters.count !== this.exercise.answeredCounters.answered && this.countDown === null) {
            this.initializeDeadlineCountDown()
          }
        })
        .catch((error) => {
          if (error.status === 404) {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    },
    setObjectAnswer (exerciseOption) {
      if (!this.exercise.exerciseIsReplied) {
        switch (this.exercise.exercise.type) {
          case 'OM':
            if (this.exercise.exercise_option_id.includes(exerciseOption.id)) {
              this.exercise.exercise_option_id.splice(this.exercise.exercise_option_id.indexOf(exerciseOption.id), 1)
            } else {
              this.exercise.exercise_option_id.push(exerciseOption.id)
            }
            break

          default:
            if (this.exercise.exercise_option_id) {
              this.exercise.exercise_option_id =
              this.exercise.exercise_option_id !== exerciseOption.id
                ? exerciseOption.id
                : 0
            } else {
              this.exercise.exercise_option_id = exerciseOption.id
            }
            break
        }
      }
    },
    getAlternativeText (index) {
      return String.fromCharCode(65 + parseInt(index))
    },
    getExerciseTitleText (index, sum) {
      return parseInt(index) + parseInt(sum)
    },
    /**
    * Seta o próximo exercício a ser respondido e exercício anterior, bem como a posição(index) do exercício
    * atual
    */
    setPreviousAndNextExercise () {
      this.totalExercises = Object.keys(this.exerciseList.instances).length
      Object.keys(this.exerciseList.instances).map(index => {
        if (this.exerciseList.instances[index].id === this.exerciseList.nextExercise) {
          this.exercisePosition = index
          this.previousExercise = typeof this.exerciseList.instances[parseInt(index) - 1] !== 'undefined'
            ? this.exerciseList.instances[parseInt(index) - 1].id
            : 0

          this.nextExercise = typeof this.exerciseList.instances[parseInt(index) + 1] !== 'undefined'
            ? this.exerciseList.instances[parseInt(index) + 1].id
            : 0
        }
      })
    },
    /**
     * Passa para o próximo exercício ou para a próxima aula caso esteja no último exercício
     * da lista e todos os exercícios da lista tenham sido respondidos
     */
    toNext () {
      if (this.nextExercise === 0) {
        this.$emit('nextLesson')
      } else {
        this.exerciseList.nextExercise = this.nextExercise
        this.setExercise()
      }
    },
    /**
     * Passa para o exercício anterior ou para a aula anterior caso esteja no primeiro exercício
     * da lista
     */
    toPrevious () {
      if (this.previousExercise === 0) {
        this.$emit('previousLesson')
      } else {
        this.exerciseList.nextExercise = this.previousExercise
        this.setExercise()
      }
    },
    /**
     * Define se esta opção é a correta
     */
    isTheOptionCorrect (exerciseOption) {
      return this.exercise.exerciseIsReplied ? exerciseOption.correct : false
    },
    /**
     * Define se esta opção é a correta
     */
    isTheOptionIncorrect (exerciseOption) {
      return this.exercise.exerciseIsReplied ? !exerciseOption.correct : false
    },
    /**
     * Envia a resposta do exercício atual para o banco de dados
     */
    async answerExercise () {
      if (this.exercise.exercise.type === 'M' && !this.exercise.file_id) {
        await this.uploadRecord()
      }

      const data = {
        exercise_list_instance_exercise_id: this.exercise.id,
        exercise_option_id: this.exercise.exercise_option_id,
        reply: this.exercise.reply,
        cells_answers: this.exercise.cells_answers,
        file_id: this.exercise.file_id,
        enrollment_id: parseInt(this.matriculaId)
      }

      SalaDeAula.answerExercise(data)
        .then((response) => {
          this.$store.commit('SalaDeAula/updateLessonProgress', { lessonId: parseInt(this.aulaId), progress: response.body.return.lesson_progress })
          this.$toasted.global.success({ message: response.body.return.message })
          this.files = []
          this.setExercise()
        })
        .catch((error) => {
          if (error.status === 422 && error.body.errors) {
            const self = this
            Object.values(error.body.errors).forEach((item) => {
              self.$toasted.global.error({ message: item })
            })
          } else if (error.status === 500 || error.status === 412 || error.status === 404) {
            this.$toasted.global.error({ message: error.body.return.message })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    },
    /**
     * Recebe um objeto que representa uma instância de File no banco de dados,
     * e a inclui no array de arquivos que farão parte da resposta do aluno para
     * uma questão objetiva com envio
     *
     * @param file objeto que representa uma instância de File no banco de dados
     */
    newFile (file) {
      this.files.push(file)
      this.generateReplyByFiles()
      if (!this.uploadForm.list) {
        this.uploadArea().showList()
      }
    },
    /**
     * Recebe um objeto file e o remove da listagem, bem como do banco de dados
     *
     * @param file objeto que representa uma instância de File no banco de dados
     */
    deleteFile (file) {
      this.files.forEach((item, key) => {
        if (item.title.localeCompare(file.title) === 0) {
          File.deleteFile(file.title)
            .then((response) => {
              this.$toasted.global.success({ message: response.body.message })
              this.files.splice(key, 1)
              this.$forceUpdate()
              if (this.files.length === 0) {
                this.exercise.reply = null
                this.uploadArea().showList()
              } else {
                this.generateReplyByFiles()
              }
            })
            .catch((error) => {
              if (error.status === 409 || error.status === 503) {
                this.$toasted.global.error({ message: error.body.message })
              } else {
                this.$toasted.global.error({ message: error.statusText })
              }
            })
        }
      })
    },
    /**
     * Gera uma resposta para o exercício objetivo com envio baseado nos arquivos que foram feitos upload
     */
    generateReplyByFiles () {
      this.exercise.reply = '<ul class="exercise-answer-images">'
      this.files.forEach((item) => {
        this.exercise.reply += '<li class="exercise-answer-item">'
        this.exercise.reply += '<img style="display: block; margin-left: auto; margin-right: auto; max-width: 100%;" height: auto src="/upload/get-file/'
        this.exercise.reply += item.title
        this.exercise.reply += '" alt="" />'
        this.exercise.reply += '</li>'
      })
      this.exercise.reply += '</ul>'
    },
    /**
     * Inicializa o timer que representa o tempo restante para
     * se responder a lista de exercícios
     */
    initializeDeadlineCountDown () {
      // Verifica se a lista de exercícios possui uma deadline definida
      // eslint-disable-next-line no-prototype-builtins
      console.log('initializeDeadlineCountDown', this.exerciseList.deadlineCountDownEnd)
      if (this.exerciseList.deadlineCountDownEnd) {
        // Define que o contador deve ser mostrado
        this.deadlineCountDown.show = true
        const vm = this

        const countDownDate = new Date().getTime() + (this.exerciseList.deadlineCountDownEnd * 1000)

        // Atualiza o contador a cada 1 segundo
        this.countDown = setInterval(function () {
          // Calcula os segundos e minutos a partir da diferença
          const distance = Math.floor((countDownDate - (new Date().getTime())) / 1000)

          // Se a distância for negativa, finaliza o contador
          if (distance < 0) {
            clearInterval(this.countDown)
            vm.deadlineCountDown.expired = true
          } else {
            const minutes = Math.floor(distance / (60))
            const seconds = Math.floor(distance - (minutes * 60))

            // Monta a string do contador a ser mostrado
            vm.deadlineCountDown.timer = minutes.toString().padStart(2, '0') + 'min e ' + seconds.toString().padStart(2, '0') + 's'
          }
        }, 1000)
      }
    },
    /**
     * Retorna os dados de um arquivo, caso este exista
     */
    fileData () {
      return this.exercise.file ? this.exercise.file.data : null
    },
    /**
     * Retorna os dados do arquivo de feedback, caso este exista
     */
    feedbackData () {
      return this.exercise.feedbackFile ? this.exercise.feedbackFile.data : null
    },
    /**
     * Trata o evento emitido quando se grava um áudio
     * como resposta de um exercício
     *
     * @param fileParam Blob contendo o arquivo de áudio
     */
    recordedHandle (fileParam) {
      this.exercise.file.data = fileParam
    },
    /**
     * Realiza o upload do áudio gravado para que este
     * seja utilizado como resposta para o exercício
     */
    async uploadRecord () {
      const formData = new FormData()
      formData.append('file', this.exercise.file.data)

      await File.uploadFile(formData)
        .then((response) => {
          // Mostra uma mensagem que o upload foi realizado com sucesso
          // e seta o id do arquivo na propriedade file_id do exercício,
          // vinculando assim o arquivo como a resposta do exercício
          this.$toasted.global.success({ message: 'Upload realizado com sucesso!' })
          this.exercise.file_id = response.body.file.id
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.body.message })
        })
    },
    async loadRecord (fileId) {
      await AuthFile.getFileById(fileId)
        .then((response) => {
          this.exercise.file.data = response.bodyBlob
          this.$forceUpdate()
        })
        .catch((error) => {
          if (error.status === 404 || error.status === 412) {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            console.log(error)
          }
        })
    },
    async loadFeedbackRecord (fileId) {
      await AuthFile.getFileById(fileId)
        .then((response) => {
          this.exercise.feedbackFile.data = response.bodyBlob
          this.$forceUpdate()
        })
        .catch((error) => {
          if (error.status === 404 || error.status === 412) {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            console.log(error)
          }
        })
    }
  },
  mounted () {
    if (typeof this.exerciseList.instances !== 'undefined') {
      this.setPreviousAndNextExercise()
      this.setExercise()
    } else {
      this.$toasted.global.warning({ message: 'Nenhuma lista de exercícios doi definida.' })
    }
  },
  beforeDestroy () {
    clearInterval(this.countDown)
  },
  computed: {
    ...mapGetters({
      sendingAnswer: 'App/loading'
    }),
    showNavigationButtons () {
      return (this.isPreviousLesson || this.isNextLesson || this.previousExercise || this.nextExercise) && (this.exercisePosition !== 0)
    },
    isPreviousLesson () {
      return this.previousLesson ? typeof this.previousLesson.id !== 'undefined' : false
    },
    isNextLesson () {
      return this.nextLesson ? typeof this.nextLesson.id !== 'undefined' : false
    },
    isObjectiveExercise () {
      return this.exercise.exercise.id !== 0
        ? ['O', 'OO', 'OM'].includes(this.exercise.exercise.type)
        : false
    },
    showOptions () {
      return this.exercise.exercise.id !== 0
        ? (['O', 'OM'].includes(this.exercise.exercise.type) ||
          (this.exercise.exercise.type === 'OO' && (this.exercise.exerciseIsHalfReplied ||
          !this.exercise.exerciseIsReplied)))
        : false
    },
    showTextArea () {
      return this.exercise.exercise.id !== 0
        ? ((this.exercise.exercise.type === 'OO' && !this.exercise.exerciseIsHalfReplied && !this.exercise.exerciseIsReplied) ||
          (['DD', 'D'].includes(this.exercise.exercise.type) && !this.exercise.exerciseIsReplied))
        : false
    },
    showYourAnswer () {
      return (this.exercise.exerciseIsReplied &&
        ['D', 'DD', 'OO', 'M', 'OL', 'DL'].includes(this.exercise.exercise.type)) ||
        this.exercise.exerciseIsHalfReplied
    },
    /**
     * Retorna a justificativa para a opção correta de exercícios objetivos e objetivos com envio
     * caso esta exista
     */
    exerciseJustification () {
      let justification = null
      if (this.exercise.exercise.id !== 0) {
        Object.keys(this.exercise.exercise.exercise_options).forEach((item) => {
          justification = this.exercise.exercise.exercise_options[item].correct &&
              this.exercise.exercise.exercise_options[item].justification
            ? this.exercise.exercise.exercise_options[item].justification
            : null
        })
      }

      return justification
    },
    /**
     * Verifica se o exercício atual foi respondido pelo sistema,
     * devido ao aluno não responder a tempo
     */
    isAnsweredBySystem: {
      get () {
        return !this.exercise.exercise_option_id &&
          !this.exercise.reply &&
          !this.exercise.file_id &&
          this.exercise.grade === 0
      }
    },
    /**
     * Data formatada de acordo com o com a região para fácil visualização
     */
    exerciseListStart: {
      get () {
        return new Date(this.exerciseList.created_at).toLocaleString('pt-BR')
      }
    },
    /**
     * Alternativas do exercício formatadas de modo a serem utilizadas
     * em um select
     */
    exerciseOptionItems: {
      get () {
        return this.exercise.exercise.exercise_options
          ? this.exercise.exercise.exercise_options.map((option) => ({ text: option.description, value: option.id }))
          : []
      }
    }
  }
}
</script>
<style lang="scss">
  .lesson-list {
    margin: auto;
    height: auto;

    .content.column {
      flex-direction: column;
      img {
        max-width: 100%;
      }
    }
  }

  .option {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    border-radius: 2px;
    padding: 10px;
    background-color: #f0f0f0;
  }

  .option-description > p{
    margin-bottom: 0 !important;
  }

  .option .option-action {
    margin-right: 5px;
  }

  .option .option-action .input-group {
    .input-group__details {
      display: none;
    }
  }

  .option .option-content {
    text-align: left;
  }

  .option .option-content .option-text {
    p:last-child {
      margin-bottom: 0;
    }
  }

  .option .option-content:hover {
    cursor: pointer;
  }

  .send-answer-action {
    display: flex;
    justify-content: flex-end;
  }

  .card-content {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    flex-grow: 1;
  }

  .exercise-tips {
    .tip .tip-title {
      display: flex;
      justify-content: flex-start;
    }

    .tip .tip-description {
      display: flex;
      justify-content: flex-start;
    }
  }

  .your-answer .answer-content {
    white-space: pre-wrap;
    text-align: justify;
  }

  ul.exercise-answer-images {
    flex-grow: 1;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    li.exercise-answer-item {
      list-style: none;
      padding: 5px 10px;
      img {
        width: 280px;
        height: auto;
        max-width: 100%;
      }
    }
  }

  .deadline-countdown {
    .deadline-expired {
      color: red;
    }
  }

  .exercise-cell-select {
    border-style: dashed;
    border-radius: 5px;
    padding: 2px;
    display: inline;
    max-width: 120px;
  }

  .exercise-cell-input {
    max-width: 120px;
    border: 0;
    border-bottom: 2px dotted;
  }
</style>
